(function() {
	'use strict';
	angular.module('app.core')
		.directive('leandnaPagination', leandnaPagination);
	
	leandnaPagination.$inject = [];
	function leandnaPagination() {
		return {
			restrict: 'EA',
			templateUrl: '/application/f/core/grid/leandna-paging-template.html',
			scope: {
				gridService: '=',
				reloadTable: '='
			},
			controller: paginationController,
			controllerAs: 'paginationController',
			bindToController: true
		};
	}
	
	paginationController.$inject = ['$scope'];
	function paginationController($scope) {
		var vm = this;
		this.$onInit = function () {
			vm.paginationObject = vm.gridService.getPaginationObject();
		};
		vm.gotoPage = gotoPage;	
		vm.locale = globalConfig.browser.locale;

		vm.enableNextPage = enableNextPage;

		function enableNextPage() {
			return vm.paginationObject.currentPage < vm.paginationObject.totalPages
				|| vm.paginationObject.pagingResultsTimedOut;
		}

		function gotoPage(page) {
			if (page) {
				if(page == vm.paginationObject.currentPage){
					return;
				}
				vm.paginationObject.currentPage = page;
				if(vm.paginationObject.currentPage == vm.paginationObject.onPage){
					return;
				}
			}
			if((page > vm.paginationObject.totalPages || vm.paginationObject.currentPage > vm.paginationObject.totalPages) && !vm.paginationObject.pagingResultsTimedOut){
				vm.paginationObject.currentPage = vm.paginationObject.totalPages;
				return;
			}	
			vm.paginationObject.currentPage = parseInt(vm.paginationObject.currentPage);
			if (isNaN(vm.paginationObject.currentPage)  || vm.paginationObject.currentPage < 1) {
				vm.paginationObject.currentPage = 1;
				return;
			}
			if(page < 1){
				return;
			}
			vm.paginationObject.currentStart = (vm.paginationObject.currentPage - 1) * vm.paginationObject.pageSize;
			vm.reloadTable();
		}
	}
})();
